/* eslint-disable import/prefer-default-export */
import { useQuery } from 'react-query';
import filtresActions from '../actions/filtres.actions';

export function useGetFiltres() {
    return useQuery('filtres', filtresActions.list);
}
